<template>
  <div>
    <zg-kh-account-modify account-center="fundAccountHome"></zg-kh-account-modify>
    <div class="fix-height"></div>
  </div>
</template>

<script>
import { AccountModify } from 'zgkaihu'
export default {
  name: 'FundAccountTenpayAccountModify',
  components: { [AccountModify.name]: AccountModify }
}
</script>

<style lang="scss" scoped>
.fix-height {
  height: 200px;
}
</style>
